import { MultiStepFormState } from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form-item';
import {
  MultiStepFormProvider,
  SubmitHandlerWithDirtyFields,
} from '@delmonicos/shared-design-system-react/src/contexts/multi-step-form.provider';
import { GetLocationsPaginatedModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/emsp-bo/models/inputs/locations/get-locations-paginated.model';
import { SubmitErrorHandler } from 'react-hook-form';

import { useFilterEmspBoLocationListContext } from '../../../emsp-bo-location.context';
import { EmspBoLocationListFilterFormStep1Controller } from '../emsp-bo-location-list-filter-form-step-1/emsp-bo-location-list-filter-form-step-1.controller';

export interface EmspBoLocationListFilterFormControllerProps {
  onError: SubmitErrorHandler<GetLocationsPaginatedModel>;
  onSubmit: SubmitHandlerWithDirtyFields<GetLocationsPaginatedModel>;
  onCancel: () => void;
  state: MultiStepFormState;
}

export const EmspBoLocationListFilterFormController = (
  props: EmspBoLocationListFilterFormControllerProps,
): React.JSX.Element => {
  const { onError, onSubmit, onCancel, state } = props;
  const data = useFilterEmspBoLocationListContext();

  return (
    <MultiStepFormProvider<GetLocationsPaginatedModel>
      useFormProps={{ mode: 'all', defaultValues: data }}
      submitErrorHandler={onError}
      submitHandler={onSubmit}
      onCancel={onCancel}
      state={state}
      items={[
        {
          fields: ['cpoId', 'country', 'city', 'name'],
          component: <EmspBoLocationListFilterFormStep1Controller />,
        },
      ]}
    />
  );
};
